import Ajax from '@ln/core/pwa/ajax';
import * as BucketTools from "../common/bucket";
import * as Utilities from "../common/utilities";

const urlUltimasNoticias = window.config.Statics.ApiContenidoUrlRoot + window.config.Statics.ApiUltimasNoticias;
const bucket = window.config.Statics.BucketUrl;

export const getUltimasNoticias = () => {
    Ajax.get(urlUltimasNoticias + "&h=1")
        .then(rs => renderUltimasNotas(JSON.parse(rs)));
}

const renderUltimasNotas = (notas) => {

    if (notas != null && notas.items != null && notas.items.length > 0) {
        let cssClass = "s noticia foto tema floatFix";
        //cssClass = notas.css === "" ? cssClass.replace("foto","") : cssClass;
        const arrayIdsNotas = [];
        let notasRender = notas.items;
        if(notasRender.length > 0 && notasRender.length > 6) {
            notasRender = notasRender.slice(0, 6);
        }

        //<!-- Últimas Noticias -->
        let html = `<div class="techo-2 floatFix">
                        <a href="/ultimas-noticias">
                            <b>Últimas noticias</b>
                        </a>
                    </div>
                    <div>`;
        let toi = 501;
        
        for (let nota of notasRender) {
            //Array utilizado para hacer el filtro de notas repetidas con Preferencias.
            arrayIdsNotas.push(nota.id);

            const hora = nota.fechaActualizacion.split(":")[0].substr(nota.fechaActualizacion.split(":")[0].length - 2, 2) + ":" + nota.fechaActualizacion.split(":")[1];//nota.fechaActualizacion.substr(9, 5);
            let tag;
            let tagHtml = "";
            const tags = nota.tags;

            if (tags && tags.length > 0) {
                tag = tags[0];
                tagHtml = `<h3><a href="${Utilities.formatoUrlAcuTag(tag.valor, tag.id)}">${tag.valor}</a></h3>`;
            }
            let imageUrl = " ";
            if(nota.imagenes instanceof Array  && nota.imagenes.length > 0 && nota.imagenes[0].src != null && nota.imagenes[0].src != "") {
                imageUrl =`<img src="${BucketTools.urlBucketBalance(bucket, nota.imagenes[0].src, "", 130)}"/>`;
            }
            let toiPos = "toi".concat(toi.toString());
            html += `<article class="${cssClass}" data-id="${nota.id}" data-notaid="${nota.id}" data-source="ultimas" data-pos="${toiPos}">
                    <div class="hora">
                        ${hora}
                    </div>
                    <a class="figure" href="/${nota.url}">
                        ${imageUrl}
                    </a>
                    <div>
                        <h2>
                            <a href="/${nota.url}">
                                ${nota.titulo}
                            </a>
                        </h2>
                        ${tagHtml}
                    </div>
                </article>`;
            toi++;
        }

        localStorage.setItem("notasUltimasNoticias", arrayIdsNotas);

        html += `<div class="botones">
                <a href="/ultimas-noticias">VER MÁS ÚLTIMAS NOTICIAS</a>
             </div>
             </div>`;
        document.querySelector("section #ultimas-noticias").insertAdjacentHTML("afterbegin", html);
    }
}


// WEBPACK FOOTER //
// ./Statics/scripts/home/ultimasNoticias.js